import React, { useState, useEffect, Fragment } from "react";
import { Row, Col } from "reactstrap";
import axios from 'axios';
import Table from "./../../components/general/Table/Table";
import Loading from "../../components/wrapper/Loading/Loading";

const PrintOrderSheetPage = () => {
  const [truckData, setTruckData] = useState([]); // State for truck data
  const [isLoading, setIsLoading] = useState(true); // State for loading status
  const [noDataFound, setNoDataFound] = useState(false); // State for no data found
  const [dataToExport, setDataToExport] = useState([]); // State for data to export

  const fetchTruckData = () => {
    setIsLoading(true);
    setNoDataFound(false);

    axios
      .get(`${process.env.REACT_APP_API_HOST}/truck/print-order-sheet-list/all`, { withCredentials: true })
      .then((response) => {
        const result = response.data.trucks;
        console.log(result);

        setTruckData(result);
        setIsLoading(false);
        setNoDataFound(result.length === 0);
      })
      .catch((error) => {
        console.error("Error fetching truck data:", error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchTruckData();
  }, []);

  // Update print order sheet data with the new data
  const updatePrintOrderSheetData = (data) => {
    console.log('data', data);
    setDataToExport((prevDataToExport) => {
      const updatedDataToExport = [...prevDataToExport];
  
      const index = updatedDataToExport.indexOf(data);
      console.log('index', index);
      if (index > -1) {
        updatedDataToExport.splice(index, 1);
      } else {
        updatedDataToExport.push(data);
      }
  
      console.log(updatedDataToExport);
  
      return updatedDataToExport;
    });
  };

  const ExportToCSV = () => {
    if (dataToExport.length === 0) {
      alert("No data selected for export");
      return;
    }
  
    axios
      .post(`${process.env.REACT_APP_API_HOST}/truck/print-order-sheet/all/`, {
        truckIds: dataToExport.map(item => item),
      }, { withCredentials: true })
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.data.downloadUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log("Data exported successfully", response.data);
      })
      .catch((error) => {
        console.error("Error exporting data:", error);
      });
  };
  
  
  const tableHeaders = ["Select", "Vendor Name", "License Plate", "Side Dims.", "Back Dims.", "Over Cab Dims."];

  return (
    <Fragment>
      <Loading loading={isLoading} label="Loading Truck Data..." />
      <Row>
        <Col lg="12">
        <Col lg="12">
          <Row className="d-flex justify-content-end align-items-center mb-2 mr-1">
            <button className="btn btn-primary" onClick={ExportToCSV}>Export CSV</button>
          </Row>
          </Col>
          {noDataFound ? (
            <div className="text-center">No data found</div>
          ) : (
            <Table
              id="truck-data-table"
              title="Truck Data"
              headers={tableHeaders}
              data={truckData.map(truck => [
                { id: truck.truck_id },
                truck.name,
                truck.license_plate,
                truck.side_dim,
                truck.back_dim,
                truck.over_cab_dim,
              ])}
              updatePrintOrderSheetData={updatePrintOrderSheetData}
              checkedData={dataToExport}
            />
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default PrintOrderSheetPage;
